
export default {
  // Navbar
  "nav.home": "Home",
  "nav.about": "About",
  "nav.services": "Services",
  "nav.portfolio": "Portfolio",
  "nav.contact": "Contact",
  "nav.start": "Get Started",

  // Hero
  "hero.subtitle": "This is where your journey begins. Easier. Faster. More reliable.",
  "hero.cta": "Explore Now",
  "hero.calls": "Calls",
  "hero.message": "Message",
  "hero.whatsapp": "WhatsApp",

  // Services
  "services.title": "OUR SERVICES",
  "services.description": "We provide reliable and efficient freight transportation services throughout the United States. Our box trucks are fully equipped to handle commercial deliveries, scheduled pickups, and time-sensitive shipments with punctuality and professional care.",
  "services.freight.title": "Freight Transportation Services",
  "services.freight.item1": "Dry and general freight transportation",
  "services.freight.item2": "Local and regional deliveries",
  "services.freight.item3": "Responsible cargo handling",
  "services.freight.item4": "Compliance with established times and routes",
  "services.logistics.title": "Logistics Services",
  "services.logistics.item1": "Load coordination and planning",
  "services.logistics.item2": "Shipment tracking and control",
  "services.logistics.item3": "Constant communication with the client",
  "services.logistics.item4": "Documentation and operational management",
  "services.commitment.title": "Operational Commitment",
  "services.commitment.item1": "Safe and reliable operations",
  "services.commitment.item2": "Compliance with federal and state regulations",
  "services.commitment.item3": "Professional and personalized attention",
  "services.commitment.item4": "Fast response and efficient service",

  // Portfolio / Trust
  "portfolio.title": "Your cargo in professional hands. Your peace of mind is our priority.",
  "portfolio.description": "We take care of your cargo with professional, safe, and reliable service.",

  // Coverage
  "coverage.title": "COVERAGE",
  "coverage.p1": "SunRoute Group is covering more territory than ever. We offer our services throughout the United States, providing the support your operation needs, no matter where you are.",
  "coverage.p2": "We have a strategically positioned operational network, which allows us to guarantee fast response times, efficient deliveries, and high-quality service in every region. Our commitment is to be close to you and your cargo, whenever you need us.",

  // Why Choose Us
  "why.title": "WHY CHOOSE US?",
  "why.security.title": "Safety and compliance",
  "why.security.desc": "We operate with the highest safety standards.",
  "why.delivery.title": "On-time deliveries",
  "why.delivery.desc": "We always meet agreed-upon deadlines.",
  "why.operation.title": "Efficient operation",
  "why.operation.desc": "Optimized processes for maximum efficiency.",
  "why.support.title": "Reliable support",
  "why.support.desc": "Dedicated support when you need it.",

  // Contact
  "contact.badge": "CONTACT",
  "contact.title": "CONTACT US",
  "contact.description": "We are at your disposal to assist you. Please complete the form and we will contact you as soon as possible.",
  "contact.info.phone": "Phone",
  "contact.info.email": "Email",
  "contact.info.location": "Location",
  "contact.info.whatsapp": "Message us on WhatsApp",
  "contact.info.hours.title": "Business Hours",
  "contact.info.hours.everyday": "Every Day",
  "contact.info.hours.available": "Available 24 hours a day, 7 days a week",
  "contact.form.title": "Send Us a Message",
  "contact.form.subtitle": "We will respond within 24 hours",
  "contact.form.name": "Full Name",
  "contact.form.name.placeholder": "Your full name",
  "contact.form.email": "Email",
  "contact.form.email.placeholder": "your@email.com",
  "contact.form.phone": "Phone",
  "contact.form.phone.placeholder": "(123) 456-7890",
  "contact.form.company": "Company",
  "contact.form.company.placeholder": "Your company name",
  "contact.form.service": "Service of Interest",
  "contact.form.service.select": "Select a service",
  "contact.form.service.freight": "Freight Transportation",
  "contact.form.service.logistics": "Logistics Services",
  "contact.form.service.consulting": "Operational Consulting",
  "contact.form.service.other": "Other",
  "contact.form.message": "Message",
  "contact.form.message.placeholder": "Tell us how we can help with your cargo or logistics...",
  "contact.form.message.hint": "Describe your needs in as much detail as possible",
  "contact.form.submit": "Send Message",
  "contact.form.sending": "Sending...",
  "contact.form.privacy": "Your information is safe. We do not share your data with third parties.",
  "contact.form.success.title": "Message sent successfully!",
  "contact.form.success.desc": "We will get in touch with you soon. Check your email.",
  "contact.form.error.name": "Please enter your full name.",
  "contact.form.error.email": "Please enter a valid email address.",
  "contact.form.error.message": "Please write a message.",
  "contact.form.error.maxlength": "The message cannot exceed 500 characters.",
  "contact.form.error.general": "There was an error sending. Please try again.",

  // About
  "about.title": "ABOUT US",
  "about.p1": "We are a freight transportation company committed to providing safe, efficient, and reliable logistics solutions. We specialize in the transportation of merchandise, guaranteeing punctuality, responsibility, and a high standard of service in every delivery.",
  "about.p2": "Our team works with professionalism and dedication, using efficient processes and complying with all industry regulations, with the goal of ensuring that each load reaches its destination in optimal conditions. We understand the importance of trust in freight transportation, which is why we focus on offering transparent, responsible service oriented to the needs of our clients.",
  "about.p3": "In our company, safety, efficiency, and commitment are the foundation of every operation.",

  // Footer
  "footer.contact": "CONTACT US",
  "footer.rights": "All rights reserved."
};
